import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { EventFlowForm } from "./EventFlowForm";

interface EventFlowModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  flowId?: string | null;
}

export function EventFlowModal({ open, onOpenChange, flowId }: EventFlowModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {flowId ? "Edit Event Flow" : "Add New Event Flow"}
          </DialogTitle>
        </DialogHeader>
        <EventFlowForm
          flowId={flowId}
          onClose={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}